import Themeable from "vuetify/lib/mixins/themeable";
import {
	VCard,
	VCol,
	VContainer,
	VExpansionPanel,
	VExpansionPanelContent,
	VExpansionPanelHeader,
	VExpansionPanels,
	VIcon,
	VRow
} from "vuetify/lib";


export default {
	name: "KAlertPanel",

	mixins: [ Themeable ],

	data: () => ( {
		open: false
	} ),

	render() {
		return <VExpansionPanels class="mb-1" flat light>
			<VExpansionPanel class="warning brown--text">
				<VExpansionPanelHeader ripple>
					<VContainer class="pa-0" fluid>
						<VRow align="center" class="fill-height">
							<VCol class="py-0 shrink">
								<VIcon>warning</VIcon>
							</VCol>

							<VCol class="py-0">
								{this.$slots.header}
							</VCol>
						</VRow>
					</VContainer>
				</VExpansionPanelHeader>

				<VExpansionPanelContent>
					<VCard dark={this.isDark} flat>
						{this.$slots.default}
					</VCard>
				</VExpansionPanelContent>
			</VExpansionPanel>
		</VExpansionPanels>;
	}
};
